import React from 'react'
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../Layout';
import Login from '../Components/AuthComponent/SignInProcess/login';
import ForgotPassword from '../Components/AuthComponent/SignInProcess/forgotPassword';
import Logout from '../Components/AuthComponent/Logout';
import Dashboard from '../Components/AdminComponents/dashboard';
import Shelters from '../Components/AdminComponents/Shelter/shelters';
import UserManagement from '../Components/AdminComponents/UserManagement/users';
import UserDetail from '../Components/AdminComponents/UserManagement/UserDetail';
import UserPetDetail from '../Components/AdminComponents/UserManagement/UserPetDetail';
import Subscription from '../Components/AdminComponents/Subscription/subscriptions';
import PetManagement from '../Components/AdminComponents/PetManagement/pets';
import PetDetail from '../Components/AdminComponents/PetManagement/PetDetail';
import Settings from '../Components/AdminComponents/Settings/settings';


export default function Routing() {
  return (
    <>
      <Routes >
      <Route path="" element={<Navigate to="/login" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/logout" element={<Logout />} />
        {/* Routes for admin login with user header starts */}
        <Route path="/admin" element={<Layout />}>
          <Route path="" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="shelters" element={<Shelters />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="users/:userId" element={<UserDetail />} />
          <Route path="users/:userId/pet/:petId" element={<UserPetDetail />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="pet-management" element={<PetManagement />} />
          <Route path="pet-management/:petId" element={<PetDetail />} />
          <Route path="settings" element={<Settings />} />
        </Route>
        {/* Routes for admin login with user header ends */}
      </Routes>
      <ToastContainer />
      </>
  );
}
